import { atom } from "recoil";

export const isLoadingSocialMidiaState = atom({
    key: 'isLoadingSocialMidiaState',
    default: false
})